import { useQueryClient } from "@tanstack/react-query"
import { useCallback, useEffect, useState } from "react"

export function useStaleQueries() {
   const [hasStaleData, setHasStaleData] = useState(false)
   const [isFetching, setIsFetching] = useState(false)
   const queryClient = useQueryClient()

   useEffect(() => {
      const unsubscribe = queryClient.getQueryCache().subscribe(() => {
         // Utiliser requestAnimationFrame pour éviter les mises à jour pendant le rendu
         requestAnimationFrame(() => {
            // Check if any active query is stale
            const queries = queryClient.getQueryCache().findAll()
            const hasStale = queries.some(
               (query) =>
                  query.isActive() && query.isStale() && query.state.fetchStatus !== "fetching",
            )
            const hasFetching = queries.some(
               (query) => query.isActive() && query.state.fetchStatus === "fetching",
            )

            setHasStaleData(hasStale)
            setIsFetching(hasFetching)
         })
      })

      return () => {
         unsubscribe()
      }
   }, [queryClient])

   const refetchAll = useCallback(() => {
      const queries = queryClient.getQueryCache().findAll()
      const staleQueries = queries.filter((query) => query.isActive() && query.isStale())

      return Promise.all(staleQueries.map((query) => query.fetch()))
   }, [queryClient])

   return {
      hasStaleData,
      isFetching,
      refetchAll,
   }
}
